// src/sql/UpdateSnapDeck.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

function UpdateSnapDeck({ deck, onClose, setDecks }) {
  const [form, setForm] = useState({
    deckName: deck.deckname,
    versionNum: deck.versionnum || "",
    monthCompleted: deck.monthcompleted || "",
    deckRank: deck.deckrank || "",
    deckRanking: deck.deckranking || "",
    snapCardBackId: deck.snapcardbackid ?? deck.snapCardBackId ?? "",
    cards: Array.from({ length: 12 }, (_, i) => deck[`card${i + 1}`] || ""),
  });

  const [allCards, setAllCards] = useState([]); // all snapCards
  const [searchTerm, setSearchTerm] = useState("");
  const [dividors, setDividors] = useState([]); // 🔹 store user's available ranks/dividors
  const [cardBacks, setCardBacks] = useState([]);
  const [cardBackPickerOpen, setCardBackPickerOpen] = useState(false);
  const [cardBackSearch, setCardBackSearch] = useState("");

  const selectedCardBack =
    cardBacks.find((cb) => String(cb.id) === String(form.snapCardBackId)) || null;

  const selectedCardBackSrc = selectedCardBack?.cardbackhtml || null;

  const filteredCardBacks = cardBacks.filter((cb) => {
    const q = cardBackSearch.trim().toLowerCase();
    if (!q) return true;
    const name = (cb.name || "").toLowerCase();
    const code = (cb.code || "").toLowerCase();
    return name.includes(q) || code.includes(q) || String(cb.id).includes(q);
  });

  useEffect(() => {
    const API = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
    axios
      .get(`${API}/api/data/snapCardBacks`)
      .then((res) => setCardBacks(res.data))
      .catch((err) => console.error("Failed to fetch card backs:", err));
  }, []);

  // Fetch all cards once
  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/data/snapAllCards`
        );
        setAllCards(res.data);
      } catch (err) {
        console.error("Failed to fetch cards:", err);
      }
    };
    fetchCards();
  }, []);

  // Fetch all dividors (deck ranks) for this user
  useEffect(() => {
    const fetchDividors = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/data/snapDividors/${deck.userid}`
        );
        setDividors(res.data);
      } catch (err) {
        console.error("Failed to fetch dividors:", err);
      }
    };
    fetchDividors();
  }, [deck.userid]);

  const handleChange = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const handleCardChange = (index, cardId) => {
    setForm((prev) => {
      const updated = [...prev.cards];
      updated[index] = cardId;
      return { ...prev, cards: updated };
    });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        deckName: form.deckName,
        versionNum: form.versionNum,
        monthCompleted: form.monthCompleted,
        deckRank: form.deckRank,
        deckRanking: form.deckRanking ? parseFloat(form.deckRanking) : null,
        snapCardBackId: form.snapCardBackId ? Number(form.snapCardBackId) : null,
        ...Object.fromEntries(form.cards.map((c, i) => [`card${i + 1}`, c || null])),
      };

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/updateSnapDeck/${deck.id}`,
        payload
      );

      // Refresh decks
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/data/snapDecks/user/${deck.userid}`
      );
      setDecks(res.data);
      onClose();
    } catch (err) {
      console.error("Failed to update deck:", err);
    }
  };

  // Filter cards by search term
  const filteredCards = allCards.filter((c) =>
    c.cardname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ textAlign: "center" }}>Edit Deck</h2>

        {/* Deck Info */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "8px",
            margin: "12px",
          }}
        >
          <input
            type="text"
            placeholder="Deck Name"
            value={form.deckName}
            onChange={(e) => handleChange("deckName", e.target.value)}
            style={{ width: "100%" }}
          />
          <input
            type="text"
            placeholder="Version Number"
            value={form.versionNum}
            onChange={(e) => handleChange("versionNum", e.target.value)}
            style={{ width: "100%" }}
          />
          <input
            type="text"
            placeholder="Month Completed"
            value={form.monthCompleted}
            onChange={(e) => handleChange("monthCompleted", e.target.value)}
            style={{ width: "100%" }}
          />

          {/* 🔽 Replace Deck Rank input with dropdown */}
          <select
            value={form.deckRank}
            onChange={(e) => handleChange("deckRank", e.target.value)}
            style={{ width: "100%" }}
          >
            <option value="">Select Rank</option>
            {dividors.map((d) => (
              <option key={d.id} value={d.dividor}>
                {d.dividor}
              </option>
            ))}
          </select>

          {/* Deck Ranking */}
          {/* <input
            type="number"
            step="0.01"
            placeholder="Deck Ranking (0–100)"
            value={form.deckRanking}
            onChange={(e) => handleChange("deckRanking", e.target.value)}
            style={{ width: "100%" }}
          /> */}

          <div style={{ margin: "12px" }}>
            <h3 style={{ margin: "0 0 8px" }}>Card Back</h3>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid rgb(197, 176, 55)",
                background: "#111",
              }}
            >
              {selectedCardBackSrc ? (
                <img
                  src={selectedCardBackSrc}
                  alt="Selected Card Back"
                  style={{
                    width: "64px",
                    height: "64px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "10px",
                    border: "1px solid rgba(255,255,255,0.12)",
                    background: "rgba(255,255,255,0.05)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "0.75rem",
                    textAlign: "center",
                    padding: "6px",
                  }}
                >
                  No Back
                </div>
              )}

              <div style={{ flex: 1 }}>
                <div style={{ color: "#eee", fontWeight: 700 }}>
                  {selectedCardBack?.name || selectedCardBack?.code || "No card back selected"}
                </div>
              </div>

              <button className="button" onClick={() => setCardBackPickerOpen(true)}>
                Change
              </button>
            </div>
          </div>
        </div>

        {/* Current Deck Cards */}
        <h3 style={{ marginTop: "12px" }}>Current Cards</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "8px",
          }}
        >
          {form.cards.map((cardId, i) => {
            const card = allCards.find((c) => c.id === cardId);
            return (
              <div
                key={i}
                style={{
                  textAlign: "center",
                  border: "1px solid #444",
                  borderRadius: "6px",
                  padding: "4px",
                  background: "#111",
                }}
              >
                {card ? (
                  <>
                    <img
                      src={card.cardhtml}
                      alt={card.cardname}
                      style={{
                        width: "100%",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                      title={card.cardname}
                    />
                  </>
                ) : (
                  <span style={{ color: "#666" }}>Empty</span>
                )}
                <button
                  className="button"
                  style={{ marginTop: "1px" }}
                  onClick={() => handleCardChange(i, "")}
                >
                  Remove
                </button>
              </div>
            );
          })}
        </div>

        {/* Search and Replace */}
        <h3 style={{ marginTop: "16px" }}>Search Cards</h3>
        <input
          type="text"
          placeholder="Search by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "100%", marginBottom: "8px" }}
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "6px",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {filteredCards.map((c) => (
            <div
              key={c.id}
              style={{
                cursor: "pointer",
                textAlign: "center",
                background: "#1a1a1a",
                padding: "4px",
                borderRadius: "6px",
              }}
              onClick={() => {
                const emptyIndex = form.cards.findIndex((id) => !id);
                if (emptyIndex !== -1) {
                  handleCardChange(emptyIndex, c.id);
                } else {
                  alert("Deck is full. Remove a card first.");
                }
              }}
            >
              <img
                src={c.cardhtml}
                alt={c.cardname}
                style={{ width: "100%", borderRadius: "6px" }}
              />
              <p style={{ fontSize: "0.65rem", color: "#ccc" }}>{c.cardname}</p>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <button className="button" onClick={handleSubmit}>
            Save
          </button>
          <button
            className="button"
            style={{ marginLeft: "10px" }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>

      {cardBackPickerOpen && (
        <div className="modal-overlay" onClick={() => setCardBackPickerOpen(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "620px",      // smaller window
              padding: "18px",
            }}
          >
            <h2 style={{ textAlign: "center", marginTop: 0 }}>Select Card Back</h2>

            <input
              type="text"
              placeholder="Search card backs..."
              value={cardBackSearch}
              onChange={(e) => setCardBackSearch(e.target.value)}
              style={{
                width: "100%",
                margin: "10px 0 12px",
                background: "#1a1a1a",
                color: "rgb(197, 176, 55)",
                border: "1px solid rgb(197, 176, 55)",
                borderRadius: "6px",
                padding: "8px",
              }}
            />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
                gap: "10px",
                maxHeight: "320px",
                overflowY: "auto",
                padding: "8px",
                borderRadius: "10px",
                border: "1px solid rgba(197, 176, 55, 0.6)",
                background: "#0d0d0d",
              }}
            >
              {filteredCardBacks.map((cb) => {
                const isSelected = String(form.snapCardBackId) === String(cb.id);

                return (
                  <div
                    key={cb.id}
                    onClick={() => {
                      handleChange("snapCardBackId", cb.id);
                      setCardBackPickerOpen(false);
                    }}
                    title={cb.name || cb.code || `Card Back ${cb.id}`}
                    className="card-hover-img"
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                      padding: "4px",
                      border: isSelected
                        ? "3px solid rgb(197, 176, 55)"
                        : "1px solid rgba(255,255,255,0.15)",
                      background: isSelected
                        ? "rgba(197,176,55,0.15)"
                        : "rgba(255,255,255,0.03)",
                      boxShadow: isSelected
                        ? "0 0 12px rgba(197,176,55,0.6)"
                        : "none",
                    }}
                  >
                    {cb.cardbackhtml ? (
                      <img
                        src={cb.cardbackhtml}
                        alt={cb.name || cb.code}
                        style={{
                          width: "100%",
                          height: "90px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: "90px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#777",
                          fontSize: "0.75rem",
                          textAlign: "center",
                          padding: "6px",
                        }}
                      >
                        No Image
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div style={{ textAlign: "center", marginTop: "14px" }}>
              <button className="button" onClick={() => setCardBackPickerOpen(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UpdateSnapDeck;
